import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface WebinarInviteCardProps {
  webinarUrl: string;
  eyebrow: string;
  title: string;
  description: string;
}

/** Bloque rojo con la invitación al webinar. */
export function WebinarInviteCard({
  webinarUrl,
  eyebrow,
  title,
  description
}: WebinarInviteCardProps) {
  return <div className="bg-[#B3261E] px-6 py-8 text-center text-hueso sm:px-8" data-id="element-154" data-mp="293yfy2iic7hp">
      <p className="font-sans text-sm font-semibold tracking-[0.18em] text-hueso/70" data-id="element-155" data-mp="1bhr88jqwpz14">{eyebrow}</p>

      <h3 className="mt-3 font-serif text-2xl leading-tight sm:text-3xl" data-id="element-156" data-mp="1ggvg9723hqpv">{title}</h3>

      <p className="mx-auto mt-3 max-w-sm font-sans text-base leading-relaxed text-hueso/85" data-id="element-157" data-mp="1lenkn0jxf5ay">
        {description}
      </p>

      <a href={webinarUrl} target="_blank" rel="noopener noreferrer" className="group mt-6 inline-flex items-center justify-center gap-2 rounded-sm bg-dorado px-7 py-4 font-sans text-base font-bold text-noche transition-colors duration-150 ease-out hover:bg-dorado-deep focus:outline-none focus-visible:ring-2 focus-visible:ring-hueso focus-visible:ring-offset-2 focus-visible:ring-offset-[#B3261E]" data-id="element-158" data-mp="1pha8kqdh862v">
        Quiero Sumarme al Webinar Gratis
        <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-159" data-mp="mtl4j0x2bpjl" />
      </a>
    </div>;
}